// extracted by mini-css-extract-plugin
module.exports = {"home":"_35BTt_zwEryhL4B3g5eeUI"};